import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { JobViewRoutingModule } from './job-view-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    JobViewRoutingModule
  ]
})
export class JobViewModule { }
